import { I18n } from '@calendly/i18n'


const getScreenReaderInstructions = () => ({
  draggable: I18n.t('publisher.components.sortable.instruction')
})

const getScreenReaderAnnouncements = (items) => {
  const getPosition = ({ id }) => items.findIndex((item) => item.id === id) + 1

  return {
    onDragStart({ active }) {
      return I18n.t('publisher.components.sortable.start', { position: getPosition(active) })
    },
    onDragMove({ active, over }) {
      if (!over) return I18n.t('publisher.components.sortable.move_outside')

      return I18n.t('publisher.components.sortable.move', { position: getPosition(active), new_position: getPosition(over) })
    },
    // onDragOver is called right after onDragStart.
    // So by default you'll never see onDragStart announcement
    // https://github.com/clauderic/dnd-kit/issues/424
    onDragOver() {
      return null // if null then leave previous announcement (onDragStart)
    },
    onDragEnd({ active, over }) {
      if (!over) return I18n.t('publisher.components.sortable.end_outside', { position: getPosition(active) })

      return I18n.t('publisher.components.sortable.end', { position: getPosition(active), new_position: getPosition(over) })
    },
    onDragCancel({ active }) {
      return I18n.t('publisher.components.sortable.cancel', { position: getPosition(active) })
    }
  }
}

export const getAccessibility = (items) => ({
  container: document.body,
  announcements: getScreenReaderAnnouncements(items),
  screenReaderInstructions: getScreenReaderInstructions()
})
